import gql from 'graphql-tag';

const GET_TICKET_AUTOMATION_RULE_META = gql`
  query getTicketAutomationRuleMetaInfo(
    $automationRuleType: AutomationRuleType
  ) {
    getTicketAutomationRuleMetaInfo(automationRuleType: $automationRuleType)
  }
`;

const GET_TICKET_LISTVIEW_META = gql`
  query {
    getTicketListViewMetaInfo
  }
`;

const GET_REQUESTERS_BY_CRITERIA = gql`
  query getRequesterList($listInfo: ListInfoInput!) {
    getRequesterList(listInfo: $listInfo) {
      userList {
        userId
        firstName
        lastName
        email
        name
        account {
          name
        }
      }
    }
  }
`;

const GET_REQUESTERS_BY_CRITERIA_ASSOCIATIONS = gql`
  query getClientUserAssociationsList($input: GetClientUsersListInput!) {
    getClientUserAssociationsList(input: $input) {
      associations {
        user {
          userId
          firstName
          lastName
          email
          name
          account {
            name
          }
          associations {
            id
            client {
              name
              accountId
            }
          }
        }
      }
    }
  }
`;

const GET_TECHNICIANS_BY_CRITERIA = gql`
  query getTechnicianList($input: GetTechnicianListInput!) {
    getTechnicianList(input: $input) {
      userList {
        userId
        firstName
        lastName
        email
        name
      }
    }
  }
`;
const GET_COMPANY_USERS = gql`
  query getCompanyUsersList($listInfo: ListInfoInput!) {
    getCompanyUsersList(listInfo: $listInfo) {
      userList {
        userId
        firstName
        lastName
        email
        name
        contactNumber
      }
    }
  }
`;

export {
  GET_TICKET_AUTOMATION_RULE_META,
  GET_TICKET_LISTVIEW_META,
  GET_REQUESTERS_BY_CRITERIA,
  GET_TECHNICIANS_BY_CRITERIA,
  GET_REQUESTERS_BY_CRITERIA_ASSOCIATIONS,
  GET_COMPANY_USERS
};
